module.exports = __webpack_public_path__ + "static/media/rub-out-the-word.44c98ff5.jpg";